import { getLivePageDate } from "./format";
import { byPoolTotalDescending } from "./poolTotal";

// The Live Pools for the UTC date of `day`, largest pool first, and the name of
// the Live Pool Projections page that shows them.
export const fetchLivePools = async (day) => {
  const year = day.getUTCFullYear();
  const month = String(day.getUTCMonth() + 1).padStart(2, "0");
  const date = String(day.getUTCDate()).padStart(2, "0");
  const response = await fetch(`/api/GetLivePools/${year}-${month}-${date}`);
  const pools = [...(await response.json()).value];
  pools.sort(byPoolTotalDescending);
  return { pools, pageName: `Live Pool Projections: ${getLivePageDate(day)}` };
};
